import { render, staticRenderFns } from "./SalaryTaxDeclare.vue?vue&type=template&id=2b666d5f&scoped=true"
import script from "./SalaryTaxDeclare.vue?vue&type=script&lang=js"
export * from "./SalaryTaxDeclare.vue?vue&type=script&lang=js"
import style0 from "./SalaryTaxDeclare.vue?vue&type=style&index=0&id=2b666d5f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b666d5f",
  null
  
)

export default component.exports